import '../snippets/product-gallery.js';
import '../components/back-in-stock.js';
import '../components/duties-notice';
import Cookies from 'js-cookie';
import Swiper from "swiper";


$(document).on('ready', function () {
    $('#shopify-section-template_product').on('variantChange', function (e) {
        if (e.variant) {
            $('[data-variant-sku]').html(e.variant.sku);
        }
    });

    //Recently viewed products cookies implementation
    if (document.cookie.indexOf('_iub_cs') != -1) {
        var iubenda_id = document.cookie.split('_iub_cs-')[1].split('=')[0];
        var iubenda_cookie = JSON.parse(Cookies.get('_iub_cs-' + iubenda_id));
        var recently_vw_cookie, current_product;
        var max_products = 5;

        if (iubenda_cookie.purposes["5"] && iubenda_cookie.purposes["1"]) {
            recently_vw_cookie = Cookies.get('RECENTLY_VIEWED') != undefined ? Cookies.get('RECENTLY_VIEWED').split(',') : [];

            if (recently_vw_cookie.indexOf(current_product) == -1) {
                current_product = window.location.href.split('?')[0].split('products/')[1];

                if (recently_vw_cookie.unshift(current_product) > max_products) {
                    recently_vw_cookie.pop();
                }
                Cookies.set('RECENTLY_VIEWED', recently_vw_cookie.join(','));
            }
        }
    }

    // Initialize Swiper for color variants
    var $colorVariantsSwiper = $(".carousel-variants-wrapper");
    if ($colorVariantsSwiper.length > 0) {
        $colorVariantsSwiper.each(function() {
            new Swiper(this, {
                slidesPerView: 5.5,
                slidesPerGroup: 1,
                autoplay: false,
                speed: 2000,
                breakpoints: {
                    768: {
                        slidesPerView: 5.5,
                        spaceBetween: 8,
                    },
                    1280: {
                        slidesPerView: 6,
                        spaceBetween: 8,
                    },
                },
            });
        });
    }
});
